import { PayOffInformationform } from 'views/orders/mortgage-payoffs/services/types.d';

export type PayoffInfoFieldKey = Exclude<keyof PayOffInformationform, 'page'>;

export type PayoffInfoFieldType = 'text' | 'select' | 'date' | 'currency';

// Which fields render (inclusion). Layout comes from derivePayoffFieldRowGroups.
export const PAYOFF_INFO_FIELDS: PayoffInfoFieldKey[] = [
  'loan_number',
  'estate_id',
  'deed_date',
  'rescission_date',
  'recorded_date',
  'mortgage_amount',
  'book',
  'certificate_title',
  'document_number',
  'instrument_number',
];

export const PAYOFF_INFO_FIELD_LABELS: Record<PayoffInfoFieldKey, string> = {
  loan_number: 'orders:loan-number',
  estate_id: 'orders:property',
  deed_date: 'payoffs:deed-date',
  rescission_date: 'payoffs:recission-date',
  recorded_date: 'payoffs:recorded-date',
  mortgage_amount: 'payoffs:original-mortgage-amount',
  book: 'payoffs:book',
  certificate_title: 'payoffs:certificate-title',
  document_number: 'payoffs:document-number',
  instrument_number: 'payoffs:instrument-number',
};

const FIELD_TYPES: Record<PayoffInfoFieldKey, PayoffInfoFieldType> = {
  loan_number: 'text',
  estate_id: 'select',
  deed_date: 'date',
  rescission_date: 'date',
  recorded_date: 'date',
  mortgage_amount: 'currency',
  book: 'text',
  certificate_title: 'text',
  document_number: 'text',
  instrument_number: 'text',
};

export const getPayoffFieldType = (field: PayoffInfoFieldKey): PayoffInfoFieldType => FIELD_TYPES[field];

// Semantic pairs share a row; single or long fields take a full-width row.
const ROWS: PayoffInfoFieldKey[][] = [
  ['loan_number'],
  ['estate_id'],
  ['deed_date'],
  ['rescission_date', 'recorded_date'],
  ['mortgage_amount'],
  ['book', 'certificate_title'],
  ['document_number', 'instrument_number'],
];

export const derivePayoffFieldRowGroups = (fields?: PayoffInfoFieldKey[]): PayoffInfoFieldKey[][] => {
  if (!fields || fields.length === 0) {
    return [];
  }
  const fieldsSet = new Set(fields);
  return ROWS
    .map((row) => row.filter((field) => fieldsSet.has(field)))
    .filter((row) => row.length > 0);
};
